import axios from 'axios'
import { graphURL_new as baseURL } from '@/utils'

/** Create Axios instance */
const service = axios.create({
	timeout: 10000,
	baseURL,
	headers: {
		'Content-Type': 'application/json;charset=utf-8',
		Authorization: 'Bearer 91ade8fa3e3096a5515fe5def8613b6c',
	},
})

/** request Interceptor */
service.interceptors.request.use(
	config => {
		return config
	},
	(error: any) => {
		Promise.reject(error)
	},
)

/** Response interceptor */
service.interceptors.response.use(
	res => {
		return res.data
	},
	error => {
		return Promise.reject(error)
	},
)

export default service
